import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import Spinner3Bounce from '../components/spinner_3_bounce'
import SupportedDocumentsComponent from '../components/supported_documents/supported_documents'

export class SupportedDocuments extends PureComponent {
  state = {}

  render() {
    const { props } = this
    const { isAuthenticated, isFetching } = props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    return <SupportedDocumentsComponent />
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupportedDocuments))
